import { BaseStore, getOrCreateStore } from '@Di'
import { observable, action, computed } from 'mobx'
import window from 'global/window'
import throttle from 'lodash.throttle'

export class DeviceStore extends BaseStore {
  constructor(store, storeName) {
    super(store, storeName)

    window.addEventListener &&
      window.addEventListener(
        'resize',
        throttle(() => this.onResize(), 200)
      )

    // Fire initially to set the state
    this.onResize()
  }

  @observable width = 0
  @observable height = 0

  @computed
  get screenSize() {
    let result = 'large'

    if (this.width < 576) {
      result = 'small'
    } else if (this.width >= 576 && this.width <= 899) {
      result = 'medium'
    } else if (this.width > 899) {
      result = 'large'
    }

    return result
  }

  @action
  onResize() {
    this.width = window.innerWidth
    this.height = window.innerHeight
  }
}

export default getOrCreateStore('DeviceStore', DeviceStore)
